import { RECENT_SEARCH_CLEAR_REQ } from '../../constants/bookmarks'

export const recentSearchClear = ()=>({
    type: RECENT_SEARCH_CLEAR_REQ,
})